import { isDemo } from '../constants/config'
export default (to, from, next) => {

  // if (isDemo)
  //   next()
  //로그인 후 사이트 코드를 변경할 경우 강제 로그아웃
  if (to.params.sitename !== sessionStorage.getItem('BRAND_SITE_NAME') && sessionStorage.getItem('BRAND_SITE_NAME') !== null && sessionStorage.getItem('BRAND_SITE_NAME') !== "") {
    sessionStorage.removeItem('BRAND_USER_INFO')
    sessionStorage.removeItem('BRAND_SITE_NAME');
    // navigator.serviceWorker.getRegistrations().then(function (registrations) { for (let registration of registrations) { registration.unregister(); } });
    // if (self.name != 'reload') {
    //   self.name = 'reload';
    //   self.location.reload(true);
    // } else self.name = '';
    next('/' + to.params.sitename + '/user/login')
  } else {
    // 로그인 정보가 있을경우 다음페이지 이동
    if (sessionStorage.getItem('BRAND_USER_INFO') != null && sessionStorage.getItem('BRAND_USER_INFO').length > 0) {
      next()
    } else { //로그인 정보가 날아갔을경우 로그인 페이지 이동
      sessionStorage.removeItem('BRAND_USER_INFO');
      // navigator.serviceWorker.getRegistrations().then(function (registrations) { for (let registration of registrations) { registration.unregister(); } });
      // if (self.name != 'reload') {
      //   self.name = 'reload';
      //   self.location.reload(true);
      // } else self.name = '';
      next('/' + to.params.sitename + '/user/login')
    }
  }
}
